import { Col } from "react-bootstrap";
import { IPropsCard } from "./Interfaces";
import Icon from "components/Icon";
import LoadCard from "./LoadCard";

export default function CardSimple({children,xs,md,title,icon,load}:IPropsCard){
  return (
    <Col xs={xs} md={md} className="my-col">
      <div className="my-card">
        {
          title
          ?
          <div className="my-card-title">{icon?<Icon name={icon} styleFamily="regular"/>:<></>}<label>{title}</label></div>
          :
          <div className="my-card-title">{icon?<Icon name={icon}/>:<></>}</div>
        }
        {load?<LoadCard/>:children}
      </div>
    </Col>
  );
}